import { DEFAULT_ENDPOINT } from "./constants.helper"
import { getCurrentHostName } from "@shared/helpers"
import store from "@hub/core/src/store"

export const getCurrentEndpoint = () => {
  const hostname = getCurrentHostName()

  let endpoint = hostname.split(".")[0]

  if (endpoint === "hubdevendas" && store.getters["Auth/currentProvider"]) {
    endpoint = store.getters["Auth/currentProvider"]
  }

  return endpoint || DEFAULT_ENDPOINT
}
